import { moneyRegex, phoneRegex } from "./regex";

/**
 * 백 단위에 ,를 추가. 원(won) 가격으로 변환
 * @param number - 가격 숫자
 */
export const transformComma = (number: number): string => {
  return number.toString().replace(moneyRegex, ",");
};

/**
 * 백 단위에 ,를 추가. 원(won) 가격으로 변환
 * @param price - 가격 숫자
 * @param toFix - 소수점 자리 수
 */
export const transformWon = (price: number, toFix = 0): string => {
  if (!price) return "0";
  if (toFix) {
    return price.toFixed(toFix).toString().replace(moneyRegex, ",");
  }

  return price.toString().split(".")[0].replace(moneyRegex, ",");
};

/**
 * 날짜 형식 변경 "YYYY. MM. DD" 으로 반환
 * @param inputDate - 변환할 대상의 날짜 값
 */
export const transformDate = (inputDate: number | string | Date): string => {
  const date = new Date(inputDate);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  } as Record<string, "numeric" | "2-digit" | undefined>;

  return new Intl.DateTimeFormat("en-US", options).format(date).replaceAll("/", ". ");
};

/**
 * 핸드폰번호 '-' 구분하는 형식으로 변경
 * @param phoneNumber - 변환할 대상의 전화번호
 */
export const transformPhoneWithDash = (phoneNumber: string | number = ""): string => {
  const _phoneNumber = phoneNumber.toString().replace("+82", "0").replaceAll("-", "");

  if (_phoneNumber.length === 9) {
    return `${_phoneNumber.slice(0, 2)}-${_phoneNumber.slice(2, 5)}-${_phoneNumber.slice(5)}`;
  }

  if (_phoneNumber.length === 10) {
    return `${_phoneNumber.slice(0, 3)}-${_phoneNumber.slice(3, 6)}-${_phoneNumber.slice(6)}`;
  }

  if (_phoneNumber.length === 11) {
    return `${_phoneNumber.slice(0, 3)}-${_phoneNumber.slice(3, 7)}-${_phoneNumber.slice(7)}`;
  }

  return _phoneNumber;
};

/**
 * 유효한 전화번호 형식인지 확인
 * 유효한 전화번호 형식: +821012341234, 01012341234, 010-1234-1234, 02-123-1234, 021231234, 031-123-1234, 0311231234
 * @param phoneNumber - 유효한 형식인지 확인할 대상의 전화번호
 */
export const checkPhone = (phoneNumber: number | string): boolean => {
  const _phoneNumber = phoneNumber.toString();
  return phoneRegex.some((regexp) => regexp.test(_phoneNumber));
};
